<template>
  <div class="salaryContainer">
    <div class="circle"></div>
    <div class="title">
      年度激励实发合计
    </div>
    <div class="salary">
      <p>{{ salary.real_total ? reality : "暂无数据" | formatCurrency }}</p>
      <p @click="show = !show">{{ currentDate | formatDate }}</p>
      
    </div>

    <van-popup v-model="show" position="bottom" round>
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        title="选择年份"
        :formatter="formatter"
        :max-date="maxDate"
        :min-date="minDate"
        @confirm="confirmMonth"
        @cancel="show = false"
      />
    </van-popup>

    <p class="tip"> 若符合发放条件:<br/>年度激励应发=
      目标奖金 x 考勤系数 x 中国雷士激励系数 x[(组织激励系数 ㄨ 权重)+(个人绩效激励系数x权重)]</p>
    <div class="salary-detail">
      <div class="item" :class="{ showMore: contorl[0] }">
        <div class="label total" @click="showDetail(0)">
          <span class="icon1">应发合计</span>
          <p class="negative">{{ salary.send_total | formatCurrency }}</p>
        </div>
        <div class="label">
          <span class="label-qi">其中</span>
        </div>
        <!-- <div class="label" v-if="salary.p_merits_pay">
          <span>个人绩效系数</span>
          <p class="negative">{{ salary.p_merits_pay }}</p>
        </div>
        <div class="label" v-if="salary.c_merits_pay">
          <span>公司绩效系数</span>
          <p class="negative">{{ salary.c_merits_pay }}</p>
        </div>
        <div class="label" v-if="salary.o_merits_pay">
          <span>所在组织绩效系数</span>
          <p class="negative">{{ salary.o_merits_pay }}</p>
        </div> -->
        <!-- <div class="label" v-if="salary.p_merits_award">
          <span>个人绩效应发金额</span>
          <p class="negative">{{ salary.p_merits_award }}</p>
        </div>
        <div class="label" v-if="salary.o_merits_award">
          <span>组织绩效应发金额</span>
          <p class="negative">{{ salary.o_merits_award }}</p>
        </div>
        <div class="label" v-if="salary.c_merits_award">
          <span>公司绩效应发金额</span>
          <p class="negative">{{ salary.c_merits_award }}</p>
        </div> -->
        <!-- <div class="label" v-if="salary.y_merits_send">
          <span>年度激励应发金额</span>
          <p>{{ salary.y_merits_send }}</p>
        </div> -->
        <div class="label" v-if="salary.y_merits_send">
          <span>年度激励应发</span>
          <p class="negative">{{ salary.y_merits_send }}</p>
        </div>
        <div class="label" v-if="salary.other_merits">
          <!-- <span>其他绩效/提成补差</span> -->
          <span>销售绩效奖金</span>
          <p class="negative">{{ salary.other_merits }}</p>
        </div>
        <div class="label" v-if="salary.other_award">
          <span>其他奖金</span>
          <p class="negative">{{ salary.other_award }}</p>
        </div>
      </div>
      <div class="item" :class="{ showMore: contorl[3] }">
        <div class="label total" @click="showDetail(3)">
          <span class="icon4">个税</span>
          <p class="negative">-{{ salary.p_tax | formatCurrency }}</p>
        </div>
      </div>
      <div class="item" :class="{ showMore: contorl[1] }">
        <div class="label total" @click="showDetail(1)">
          <span class="icon2">其它扣款</span>
          <p class="negative">
            -
            {{ salary.TOO | formatCurrency }}
          </p>
        </div>
        <div class="label" v-if="salary.other_deduction">
          <span>其他扣款1</span>
          <p class="negative">-{{ salary.other_deduction }}</p>
        </div>
        <div class="label" v-if="salary.other_deduction_2">
          <span>其他扣款2</span>
          <p class="negative">-{{ salary.other_deduction_2 }}</p>
        </div>
      </div>
      <!-- <div class="item" :class="{ showMore: contorl[2] }">
        <div class="label total" @click="showDetail(2)">
          <span class="icon3">其他</span>
          <p
            :class="{
              negative:
                salary.taxoffset ||
                salary.rent ||
                salary.lend ||
                salary.other_deduction,
            }"
          >
            {{
              salary.taxoffset ||
              salary.rent ||
              salary.lend ||
              salary.other_deduction
                ? "-"
                : ""
            }}
            {{ salary.POO | formatCurrency }}
          </p>
        </div>
        <div class="label" v-if="salary.taxoffset">
          <span>个税补差</span>
          <p class="negative">-{{ salary.taxoffset }}</p>
        </div>
        <div class="label" v-if="salary.rent">
          <span>水电费房租</span>
          <p class="negative">-{{ salary.rent }}</p>
        </div>
        <div class="label" v-if="salary.lend">
          <span>借款</span>
          <p class="negative">-{{ salary.lend }}</p>
        </div>
        <div class="label" v-if="salary.other_deduction">
          <span>其他扣款</span>
          <p class="negative">-{{ salary.other_deduction }}</p>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { removeWatermark, setWaterMark } from "@/assets/js/watermark.js";
import utils from "@/assets/js/utils.js";
import api from "@/apis";
export default {
  data() {
    return {
      show: false,
      showTip: false,
      contorl: [false, false, false, false],
      currentDate: new Date(),
      hadMonth: "",
      maxDate: new Date(),
      minDate: new Date("2000/01/01"),
      timeInterval: null,
      salaryInfo: null,
      salary: {},
      month: "",
      reality: 0,
      formatSpeed: 100
    };
  },
  created() {
    // this.toLogin();
    this.salaryInfo = JSON.parse(localStorage.getItem("salaryInfo"));
    if (this.salaryInfo) {
      this.mark =
        this.salaryInfo.title +
        this.salaryInfo.mobileNo.substring(
          this.salaryInfo.mobileNo.length - 4,
          this.salaryInfo.mobileNo.length
        );
      // this.maxDate.setMonth(this.maxDate.getMonth() - 1);
      this.currentDate.setMonth(this.currentDate.getMonth() - 1);
      this.getSalary();
    } else {
      this.$router.push("/login");
    }
  },
  mounted() {
    setWaterMark(this.mark);
  },
  filters: {
    // 格式化时间
    formatDate(val) {
      return utils.formatDate(val.getTime() / 1000, "yyyy年度激励");
    },
    formatCurrency(num) {
      if (num) {
        //将num中的$,去掉，将num变成一个纯粹的数据格式字符串
        num = num.toString().replace(/$|,/g, "");
        //如果num不是数字，则将num置0，并返回
        if ("" == num || isNaN(num)) {
          return num;
        }
        //如果num是负数，则获取她的符号
        var sign = num.indexOf("-") > 0 ? "-" : "";
        //如果存在小数点，则获取数字的小数部分
        var cents = num.indexOf(".") > 0 ? num.substr(num.indexOf(".")) : "";
        cents = cents.length > 1 ? cents : ""; //注意：这里如果是使用change方法不断的调用，小数是输入不了的
        //获取数字的整数数部分
        num = num.indexOf(".") > 0 ? num.substring(0, num.indexOf(".")) : num;
        //如果没有小数点，整数部分不能以0开头
        if ("" == cents) {
          if (num.length > 1 && "0" == num.substr(0, 1)) {
            return num;
          }
        }
        //如果有小数点，且整数的部分的长度大于1，则整数部分不能以0开头
        else {
          if (num.length > 1 && "0" == num.substr(0, 1)) {
            return num;
          }
        }
        //针对整数部分进行格式化处理，这是此方法的核心，也是稍难理解的一个地方，逆向的来思考或者采用简单的事例来实现就容易多了
        /*
                  也可以这样想象，现在有一串数字字符串在你面前，如果让你给他家千分位的逗号的话，你是怎么来思考和操作的?
                  字符串长度为0/1/2/3时都不用添加
                  字符串长度大于3的时候，从右往左数，有三位字符就加一个逗号，然后继续往前数，直到不到往前数少于三位字符为止
                 */
        for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
          num =
            num.substring(0, num.length - (4 * i + 3)) +
            "," +
            num.substring(num.length - (4 * i + 3));
        }
        //将数据（符号、整数部分、小数部分）整体组合返回
        return sign + num + cents;
      }
    },
  },

  methods: {
    // 处理水印
    accumulativeMachine() {
      setTimeout(() => {
        this.formatSpeed = Math.floor(Math.random() * (200 - 100)) + 100;
        this.reality += this.formatSpeed;
        if (this.reality >= this.salary.real_total) {
          this.reality = this.salary.real_total;
          return;
        }
        this.accumulativeMachine();
      }, 20);
    },
    //获取工资信息
    getSalary() {
      api
        .getBonus({
          year: this.month,
        })
        .then((res) => {
          this.salary = res.data;
          // 其他扣款
          this.salary.TOO = (
            parseFloat(this.salary.other_deduction) +
            parseFloat(this.salary.other_deduction_2)
          ).toFixed(2);
          this.reality = 0;
          this.accumulativeMachine();
          // this.minDate = new Date(res.data.year_list.min_Term);
          // this.maxDate = new Date(res.data.year_list.max_Term);
          this.minDate = new Date(res.data.year_list.max_Term);
          this.maxDate = new Date(res.data.year_list.max_Term);
          this.currentDate = new Date(res.data.year);
          this.hadMonth = this.currentDate;
        })
        .catch(() => {
          this.currentDate = this.hadMonth;
          this.$notify({
            type: "error",
            message: "未查询倒年度激励数据",
          });
        });
    },
    // 选择月份
    confirmMonth(e) {
      this.month = utils.formatDate(e.getTime() / 1000, "yyyy");
      this.show = false;
      this.getSalary();
    },
    //格式化时间
    formatter(type, val) {
      if (type === "year") {
        return `${val}年度激励`;
      } else if (type === "month") {
        return;
      }
      return val;
    },
    showDetail(index) {
      this.$set(this.contorl, index, !this.contorl[index]);
    },
  },
  beforeDestroy() {},
  destroyed() {
    removeWatermark();
  },
};
</script>

<style lang='scss' scoped>
@font-face {
  font-family: "DINPro";
  src: url(~@/assets/font/DINPro.otf), url(~@/assets/font/DINPro.ttf);
  font-weight: normal;
  font-style: normal;
}
@keyframes easing {
  0% {
    transform: scale(0.9);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.9);
  }
}
.salaryContainer {
  background: url("~@/assets/salary/reward/reward_bg.png") no-repeat;
  background-size: 100% auto;
  @include container();
  position: relative;
  &::v-deep .van-picker__columns {
    // 把月份去了
    .van-picker-column:nth-child(2) {
      display: none;
    }
  }
  .circle {
    position: absolute;
    width: 236px;
    height: 236px;
    background: #fc7a78;
    top: 180px;
    left: 300px;
    border-radius: 50%;
    opacity: 0.5;
    z-index: 1;
    animation: easing 4s infinite linear;
  }

  .title{
    font-size: 24px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #ffffff;
    padding-left: 60px;
    padding-top: 60px;
  }

  .salary {
    position: relative;
    z-index: 2;
    padding: 10px 30px 20px 60px;
    @include flex-between();
    & > p {
      font-size: 72px;
      font-family: DINPro;
      font-weight: bold;
      color: #ffffff;
      text-shadow: 0px 4px 5px rgba(1, 137, 86, 0.17);
    }
    & > p:nth-child(2) {
      cursor: pointer;
      width: 192px;
      height: 52px;
      background: #c4170f;
      border-radius: 26px;
      font-size: 22px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 52px;
      text-align: center;
      padding-right: 24px;
      position: relative;
      &::after {
        content: "";
        display: block;
        width: 20px;
        height: 16px;
        background: url("~@/assets/salary/arrow.png") no-repeat;
        background-size: 100% 100%;
        position: absolute;
        right: 16px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  .tip {
    position: relative;
    z-index: 2;
    padding-left: 60px;
    padding-right: 30px;
    font-size: 24px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 40px;
    top: -15px;

  }
  .salary-info {
    position: relative;
    z-index: 2;
    margin: 50px auto 0;
    width: 702px;
    height: 160px;
    background: #ffffff;
    box-shadow: 0px 7px 9px 0px rgba(209, 209, 209, 0.2);
    border-radius: 15px;
    @include flex-around();
    .item {
      & > p:nth-child(1) {
        font-size: 30px;
        font-family: DINPro;
        font-weight: bold;
        color: #000000;
      }
      & > p:nth-child(2) {
        margin-top: 10px;
        font-size: 24px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #999999;
      }
    }
  }
  .salary-detail {
    margin-top: 50px;
    position: relative;
    z-index: 1;
    .item {
      width: 702px;
      margin: 0 auto;
      margin-bottom: 16px;
      background: #ffffff;
      box-shadow: 0px 7px 9px 0px rgba(209, 209, 209, 0.3);
      border-radius: 15px;
      overflow: hidden;
      max-height: 100px;
      transition: all 0.4s linear;

      .label {
        @include flex-between();
        padding: 0 30px;
        height: 80px;
        background: rgba(255, 255, 255, 0.5);

        .label-qi{
          color: black;
          font-size: 32px;
        }

        & > span {
          font-size: 28px;
          font-family: Source Han Sans SC;
          font-weight: 400;
          color: #999999;
        }
        & > p {
          font-size: 28px;
          font-family: DINPro;
          font-weight: bold;
          color: #020202;
        }
        & > .negative {
          color: #c9393e;
        }
      }
      .label:nth-child(2n) {
        background: rgba(250, 251, 253, 0.5);
      }
      .desc {
        font-size: 26px;
        font-family: Source Han Sans SC;
        color: #999999;
        line-height: 40px;
        & > p {
          margin-bottom: 20px;
          & > span {
            color: #018755;
          }
        }
      }
      .total {
        height: 100px;
        cursor: pointer;
        & > span {
          font-size: 30px;
          font-family: Source Han Sans SC;
          font-weight: 500;
          color: #020202;
          padding-left: 60px;
          position: relative;
          &::after {
            content: "";
            display: block;
            position: absolute;
            width: 44px;
            height: 44px;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
          }
        }
        & > p {
          font-size: 36px;
          font-family: Source Han Sans SC;
          font-weight: bold;
          color: #020202;
        }
        & > .icon1 {
          &::after {
            background: url("~@/assets/salary/icon1.png") no-repeat;
            background-size: contain;
          }
        }
        & > .icon2 {
          &::after {
            background: url("~@/assets/salary/icon2.png") no-repeat;
            background-size: contain;
          }
        }
        & > .icon3 {
          &::after {
            background: url("~@/assets/salary/icon3.png") no-repeat;
            background-size: contain;
          }
        }
        & > .icon4 {
          &::after {
            background: url("~@/assets/salary/icon4.png") no-repeat;
            background-size: contain;
          }
        }
        & > .icon5 {
          &::after {
            background: url("~@/assets/salary/icon5.png") no-repeat;
            background-size: contain;
          }
        }
      }
    }
    .showMore {
      max-height: none;
    }
  }
  .showTips {
    width: 116px;
    height: 120px;
    position: fixed;
    right: 40px;
    bottom: 12%;
    z-index: 10;
    & > img {
      width: 100%;
      height: 100%;
    }
  }
  &::v-deep .van-dialog {
    width: 670px;
    background: transparent;
  }
  .dialog-content {
    @include flex-center(column);

    & > div {
      width: 670px;
      padding: 40px 40px;
      background: #ffffff;
      border-radius: 15px;
      & > .title {
        margin-bottom: 30px;
      }
      & > p {
        margin-bottom: 20px;
        font-size: 26px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #020202;
        text-align: justify;
        & > span {
          color: #058655;
        }
        & > .bolder {
          font-weight: bold;
        }
      }
    }
    & > span {
      margin-top: 25px;
      width: 40px;
      height: 40px;
      background: url("~@/assets/selection/close.png") no-repeat;
      background-size: cover;
    }
  }
}

</style>